import get from 'lodash/get'
import PCLNAnalytics from '@pcln/analytics'

import { handlePackageCrossSell } from '../../util/crossSellGenericAd'
import { buildOrderedListings } from '../../util/buildOrderedListings'
import { getPriceForCurrentDate } from './listingsContentHelper.js'

/**
 * Keep this function pure,
 * For the sake of code sanity, DO NOT modify to the paramters passed to it
 * */
export function populateListingsState({
  listingsContentState,
  listingsContentProps,
  flySearchResponseData = {},
}) {
  const {
    travelDate,
    returnDate,
    tripType,
    sbsListings,
    isDesktop,
    // fireListingsImpressionsOnce
  } = listingsContentState
  const { pclnBootstrapData, calendarPricing, listingsMetaData } = listingsContentProps
  const listingsResponse = listingsContentProps.listings || {}
  const { response, lastUpdateTime } = listingsResponse
  let listings = response || []
  let minimumRetailPrice = listingsMetaData?.minimumRetailPrice ?? 0

  const hasExpressDeal = get(listingsMetaData, 'hasExpressDeal', false)
  const orderedListingsData = buildOrderedListings({
    itineraries: listings,
    hasExpressDeal,
    isRoundTrip: tripType === 'RT',
    isDesktop,
    isWhiteLabel: !!pclnBootstrapData.partner,
    isPackageListings: pclnBootstrapData.isPackageListings,
  })
  listings = orderedListingsData.listings
  if (orderedListingsData.minimumRetailPrice) {
    minimumRetailPrice = orderedListingsData.minimumRetailPrice
  }

  const { airports, exdCarriers, searchSessionKey, priceGuidance } = flySearchResponseData

  let isInternational = false

  // Populate airportToCity
  const airportToCity = {}

  if (airports) {
    Object.values(airports).forEach((currentAirport) => {
      if (currentAirport.isoCountryCode === 'US') {
        airportToCity[currentAirport.code] = `${currentAirport.city}, ${currentAirport.state}`
      } else {
        airportToCity[currentAirport.code] = `${currentAirport.city}, ${currentAirport.country}`
        isInternational = true
      }
    })
  }

  const airportsString = Object.values(airports || {})
    .map((airport) => airport?.code || '')
    .filter((airPortCode) => airPortCode)
    .join('-')

  const crossSellControlObject = handlePackageCrossSell(pclnBootstrapData, flySearchResponseData)
  const priceOnCalendar = getPriceForCurrentDate(calendarPricing, travelDate, returnDate)

  if (priceOnCalendar > 0) {
    PCLNAnalytics.log({
      action: 'ELASTIC-ACCURACY',
      label: 'difference',
      value: `${priceOnCalendar - minimumRetailPrice}`,
      isInternational: `${isInternational}`,
      airports: airportsString,
      tripType,
    })
  }

  return {
    listings,
    searchKey: searchSessionKey,
    exdCarriers,
    airportToCity,
    showLoadingMessage: false,
    loadingSuccess: true,
    crossSellControlObject,
    fireListingsImpressionsOnce: true,
    lastUpdateTime,
    minimumRetailPrice,
    priceGuidance,
    sbsListings,
  }
}
